import React from 'react';
import { FormControlLabel, Switch, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateWorkflowBasicInfo } from '../../../state';

export const WorkflowActiveSwitch: React.FC = () => {
  const dispatch = useAppDispatch();
  const currentWorkflow = useAppSelector((state) => state.workflow.currentWorkflow);

  if (!currentWorkflow) return null;

  return (
    <FormControlLabel
      control={
        <Switch
          checked={currentWorkflow.isActive}
          onChange={(e) => dispatch(updateWorkflowBasicInfo({ isActive: e.target.checked }))}
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': {
              color: '#10b981',
            },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
              backgroundColor: '#10b981',
            },
          }}
        />
      }
      label={
        <Typography sx={{ color: '#1e293b', fontWeight: 500 }}>
          Activate workflow immediately
        </Typography>
      }
    />
  );
};

export default WorkflowActiveSwitch;
